module.exports = __webpack_public_path__ + "static/img/cont40_01.7d87709.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont40_01.jpg
// module id = xTRs
// module chunks = 0